import React from 'react';

function BrandLogo({ variant = 'navbar', showAdmin = false }) {
  const logoClass =
    variant === 'footer'
      ? 'brand-logo brand-logo--footer'
      : variant === 'admin'
        ? 'brand-logo brand-logo--admin'
        : 'brand-logo';

  return (
    <span className="brand-mark">
      <img src="/assets/imgs/brand/logo1.png" alt="" className={logoClass} />
      <span className={`brand-text ${variant === 'footer' ? 'brand-text--footer' : ''}`}>
        <span className="brand-text-word">Kanus</span>
        <span className="brand-text-word brand-text-accent">Digital</span>
        {showAdmin && <span className="brand-admin-label">Admin</span>}
      </span>
    </span>
  );
}

export default BrandLogo;
